<template>
    <div>
        <div class="header">
            <div class="header_fixed">
                <div class="logo">
                    <img v-if="currentIndex === 1" src="@/assets/img/index/LOGO.png" alt="" />
                    <img src="@/assets/img/index/LOGO.png" alt="" v-else />
                </div>
                <div class="option">
                    <div v-for="(item, index) in headeList" :key="index"
                        :class="{ ac_option_one: item.id === currentIndex, blue_title: currentIndex !== 1, option_one: currentIndex == 1 }"
                        @click="clickTab(item.id)" @mouseover="addClass(item.id)">
                        <div>{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isShow" @mouseover="onMouseOverT" @mouseleave="onMouseOutT">
            <ul class='children_wrapper flex justify-center' v-if="currentIndex == 2 || currentIndex == 3">
                <div class="childrenBox letter-spacing" v-if="currentIndex == 2" style="margin-left: -120px;">
                    <div class="mt-24 font-16 text-gray5">
                        <div class="flex align-center ">
                            <img src="../assets/img/header/cpzx/jsjg.png" alt="">
                            <li @click="topath3(1)">技术架构</li>
                        </div>
                        <div class="flex align-center ">
                            <img src="../assets/img/header/cpzx/glpt.png" alt="">
                            <li @click="topath3(2)">管理平台</li>
                        </div>
                        <div class="flex align-center ">
                            <img src="../assets/img/header/cpzx/sjpt.png" alt="">
                            <li @click="topath3(3)">数据平台</li>
                        </div>
                    </div>
                </div>

                <div class="flex justify-center letter-spacing  text-left" v-if="currentIndex == 3">
                    <div class="childrenBox letter-spacing">
                        <div class="font-20 text-gray5" style="padding-top: 42px;">管理服务</div>
                        <div class="mt-24 font-16 text-gray5">
                            <div class="flex align-center ">
                                <img src="../assets/img/header/jjfa/xtgl.png" alt="">
                                <li @click="topath1(1)">协同管理</li>
                            </div>
                            <div class="flex align-center ">
                                <img src="../assets/img/header/jjfa/xmgl.png" alt="">
                                <li @click="topath1(2)">项目管理</li>
                            </div>
                            <div class="flex align-center ">
                                <img src="../assets/img/header/jjfa/ysgl.png" alt="">
                                <li @click="topath1(3)">预算管理</li>
                            </div>
                            <div class="flex align-center ">
                                <img src="../assets/img/header/jjfa/syzc.png" alt="">
                                <li @click="topath1(4)">商业资产</li>
                            </div>
                        </div>
                    </div>

                    <div class="childrenBox letter-spacing  text-left">
                        <div class="font-20 text-gray5" style="padding-top: 42px;">数据服务</div>
                        <div class="mt-24 font-16 text-gray5">
                            <div class="flex align-center ">
                                <img src="../assets/img/header/jjfa/sjzx.png" alt="">
                                <li @click="topath2(1)">存算一体数据中心</li>
                            </div>
                            <div class="flex align-center ">
                                <img src="../assets/img/header/jjfa/sjzl.png" alt="">
                                <li @click="topath2(2)">数据治理</li>
                            </div>
                        </div>
                    </div>
                </div>
            </ul>
        </div>
    </div>
</template>

<script>
let flg = true;
export default {
    name: 'Header',
    data() {
        return {
            drawer: false,
            currentIndex: 0,
            headeList: [
                { name: "首页", id: 1, },
                { name: "产品体系", id: 2, },
                { name: "解决方案", id: 3, },
                // { name: "成功案例", id: 4, },
                { name: "典型客户", id: 5, },
                { name: "关于我们", id: 6, },
            ],
            phoneList: [
                { name: "首页", id: 1 },
                { name: "产品体系", id: 2 },
                { name: "解决方案", id: 3 },
                // { name: "成功案例", id: 4 },
                { name: "典型客户", id: 5 },
                { name: "关于我们", id: 6 },
            ],
            isShow: false,
        };
    },

    created() {
        // this.clickTab(this.currentIndex)
    },

    mounted() {
        this.$root.$on('updateCurrentIndex', (index) => {
            // console.log(index)
            this.currentIndex = index
            this.isShow = false

        })
    },

    methods: {
        // 鼠标移出1
        onMouseOutO() {
            setTimeout(() => {
                if (flg) {
                    this.isShow = false
                }
            }, 1)
        },
        // 鼠标移入2
        onMouseOverT() {
            flg = false
        },
        // 鼠标移出2
        onMouseOutT() {
            flg = true
            this.isShow = false
        },

        clickTab(index) {
            let address = ''
            switch (index) {
                case 1:
                    address = 'home'
                    break
                case 2:
                    // address = 'productCenter'
                    break
                case 3:
                    // address = 'solution'
                    break
                case 4:
                    address = 'SuccessfulCases'
                    break
                case 5:
                    address = 'customer'
                    break
                case 6:
                    address = 'AboutUs'
                    break;
                default:
                    address = 'home'
            }
            this.$router.push(
                {
                    name: address,
                },
                () => { }
            );
            this.currentIndex = index;
        },

        addClass(i) {
            this.isShow = true
            this.currentIndex = i;
        },
        topath1(num) {
            if (num == 1) {
                this.$router.push({
                    name: 'Synergy'
                })
            }
            if (num == 2) {
                this.$router.push({
                    name: 'project'
                })
            }
            if (num == 3) {
                this.$router.push({
                    name: 'budget'
                })
            }
            if (num == 4) {
                this.$router.push({
                    name: 'business'
                })
            }
            this.isShow = false
        },

        topath2(num) {
            if (num == 1) {
                this.$router.push({
                    name: 'Deposit'
                })
            }
            if (num == 2) {
                this.$router.push({
                    name: 'dataInfo'
                })
            }
            this.isShow = false
        },

        topath3(num) {
            if (num == 1) {
                this.$router.push({
                    name: 'jsjg'
                })
            }
            if (num == 2) {
                this.$router.push({
                    name: 'glpt'
                })
            }
            if (num == 3) {
                this.$router.push({
                    name: 'sjpt'
                })
            }
            this.isShow = false
        },

        showMenu() {
            this.menuVisible = true;
        },
        hideMenu() {
            this.menuVisible = false;
        },
        stopHide(event) {
            event.stopPropagation(); // 阻止隐藏菜单
        }
    },
};
</script>
<style lang="scss">
.header {
    height: 60px;
    position: absolute;
    top: 22px;
    width: 100%;
    z-index: 99;
    padding: 0px 30px;
    box-sizing: border-box;

    .header_fixed {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo {
            img {
                height: 45px;
            }
        }

        .option {
            display: flex;
            font-size: 16px;

            .option_one {
                color: #0F0F0F;
                position: relative;
                margin: 0px 40px;
                cursor: pointer;

                &::after {
                    content: "";
                    display: inline-block;
                    position: absolute;
                    bottom: -20px;
                    left: 0px;
                    width: 100%;
                    height: 2px;
                    background: transparent;

                }
            }

            .ac_option_one {
                color: #2F79FF;

                &::after {
                    height: 6px !important;
                    background: #2F79FF !important;
                    border-radius: 3px 3px 3px 3px;
                    opacity: 1;

                }
            }

            .blue_title {
                position: relative;
                margin: 0px 40px;
                cursor: pointer;

                &::after {
                    content: "";
                    display: inline-block;
                    position: absolute;
                    bottom: -15px;
                    left: 0px;
                    width: 100%;
                    height: 2px;
                    color: #2F79FF;
                    background: transparent;
                }
            }
        }
    }
}

.children_wrapper {
    position: absolute;
    top: 72px;
    width: 100%;
    z-index: 2000;
    height: 382px;
    background: #FFF;
    cursor: pointer;

    .childrenBox {
        margin: 0 0 0 132px;

        li {
            line-height: 52px;
            margin-left: 12px;
        }
    }
}

.left_draw {
    padding: 60px 0px;
}

.info_box {
    display: flex;
    align-items: center;
}

.info_box_left {
    display: flex;
    align-items: center;

    img {
        height: 16px;
        margin-right: 5px;
    }

    .el_dropdown_link {
        display: flex;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
    }

    .el_dropdown_link2 {
        display: flex;
        color: #000000;
        font-size: 14px;
        cursor: pointer;
    }
}

.line {
    height: 16px;
    width: 1px;
    background-color: rgba(255, 255, 255, 0.3);
    margin: 0px 20px;
}

.line2 {
    height: 16px;
    width: 1px;
    background-color: #000000;
    margin: 0px 20px;
}

li {
    list-style: none;
}

li:hover {
    color: #2F79FF;
}

.active {
    display: block !important;
}
</style>